<template>
  <div>
    <SloButton @click="modalOpen = true" fill="outline" class="w-100">
      {{ 'Reorder' | t }}
    </SloButton>
    <transition name="fade-up">
      <SloModal v-if="modalOpen" name="fade-up" :max-width="500" :form="false" @dismiss="handleCloseModal">
        <template v-slot:title>{{ 'Reorder this cart?' | t }}</template>
        <p>{{ 'By reordering these products, your existing cart will be replaced with this reorder unless you save your current cart. Any products currently in your cart will be lost.' | t }}</p>
        <template v-slot:footer>
          <SloButton @click="handleSubmit" :disabled="loading" fill="outline" class="flex-1">
            <SloLoader :loading="loading" size="md">
              {{ 'Yes, proceed to reorder' | t }}
            </SloLoader>
          </SloButton>
          <SloButton @click="handleCloseModal" :disabled="loading" class="flex-1">
            {{ 'No, keep my current cart' | t }}
          </SloButton>
        </template>
      </SloModal>
    </transition>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import t from '../../main/i18n';
import {handleApiErrors, tagManagerTrack} from '../../main/utils';
import {marketplaceApi} from '../apis/marketplace';
import SloLoader from '../../../lib/components/SloLoader.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import SloModal from '../../../lib/components/SloModal.vue';

export default {
  name: 'ReorderOrderButton',
  components: {
    SloLoader,
    SloButton,
    SloModal
  },
  filters: {
    t
  },
  props: {
    order: {type: Object, required: true}
  },
  data() {
    return {
      loading: false,
      modalOpen: false
    };
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('marketplace', ['cartId'])
  },
  methods: {
    handleCloseModal() {
      this.modalOpen = false;
    },
    async handleSubmit() {
      this.loading = true;
      await marketplaceApi.reorderOrder(this.order.code || this.order.orderNumber)
        .then(async res => {
          tagManagerTrack('reorder_order', {
            currency: this.order?.subTotal?.currencyIso,
            user: this.user?.accountNumber || 'guest',
            cartId: this.cartId,
            items: res?.data?.cartEntries.map(cartEntry => ({
              item_id: cartEntry?.product?.code,
              item_name: cartEntry?.product?.number,
              quantity: cartEntry?.quantity,
              totalPrice: cartEntry?.totalPrice?.value
            }))
          });

          this.$snotify.success(t('Your cart has been updated, please review your cart'));
          await this.$router.push({name: 'marketplace-cart'});
        })
        .catch(e => {
          this.loading = false;
          handleApiErrors(e, this, 'Unable to reorder');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-up-enter, .fade-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-up-enter-active, .fade-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
</style>
